import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  examUserList: [],
  totalUser: 0,
  deviceList: [],
  totalDeviceChange: 0,
  isStatusOpenModal: false,
}

export const userListSlice = createSlice({
  name: "userList",
  initialState,
  reducers: {
    setUserListData(state, { payload }) {
      state.examUserList = payload.result
      state.totalUser = payload.total
    },
    setDeviceUserListData(state, { payload }) {
      state.deviceList = payload.result
      state.totalDeviceChange = payload.total
    },
      isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    },
    updateDeviceUserListData(state, { payload }) {
      const index = state.deviceList.findIndex(item => item._id === payload.id);
      if (index !== -1) {
        state.deviceList[index].status = payload.status;
      }
    }
  }
})

export const { setUserListData, setDeviceUserListData,isOpenStatusModal, statusToggle, updateDeviceUserListData } = userListSlice.actions;

export default userListSlice.reducer;

export function getUserList(limit, offset, keyword, startDate = '', endDate = '', showLoader = true) {
  return async function getUserListThunk(dispatch) {
    if (showLoader) dispatch(setLoading(true))
    try {
      await service.getUserList(limit, offset, keyword, startDate, endDate).then(
        (response) => {
          if (showLoader) dispatch(setLoading(false))
          dispatch(setUserListData(response.data))
        }, (error) => {
          if (showLoader) dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {
      if (showLoader) dispatch(setLoading(false))
    }
  }
}

export function getUserDeviceChangeList(limit, offset) {
  return async function getUserDeviceChangeListThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getUserDeviceChangeList(limit, offset).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setDeviceUserListData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function updateDeviceChangeStatus(id, status) {
  return async function updateDeviceChangeStatusThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateDeviceChangeStatus(id, status).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(updateDeviceUserListData({id, status}))
          dispatch(statusToggle())
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
